import React, { useState, useContext, useEffect, useMemo } from "react";
import AddItm from "../addItm/AddItm";
import SearchInput from "../searchInput/SearchInput";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RRChecklist from "../renderRows/RRChecklist";

import './ChecklistList.css';
import { checkDoubleQuotes, removeDoubleQuotesFromFilter } from "../../utils/funciones";
import normalizeText from "../../utils/normalizeText";

const ChecklistList = ({checklists, setChecklistToModify, setShowABM, getCheckByID, eliminarChecklist, actualizarChecklistList}) =>{

    const [filter,setFilter] = useState('');

    const handleClickAdd = () =>{
        setShowABM(false);
    }

        let checklistsFiltered = useMemo(()=> checklists?.filter(check => {
            return filter != '' ? 
                checkDoubleQuotes(filter) ?
                    normalizeText(check.codigo) == removeDoubleQuotesFromFilter(filter) || normalizeText(check.name) == removeDoubleQuotesFromFilter(filter)
                :
                    normalizeText(check.codigo).includes(normalizeText(filter)) || normalizeText(check.name).includes(normalizeText(filter))
            : true
        }), [checklists, filter]);

    return <div className="checklistsList">
        <AddItm titulo={'Checklist'} anadiritm={handleClickAdd}/>
        <SearchInput buscar={setFilter} filter={filter}/>
        {checklists != undefined && checklistsFiltered.length == 0 ? <h3 className="warningStatusMsg">No hay checklists creados</h3> : checklists == undefined ? <h3 className="warningStatusMsg"><span>.</span><span>.</span><span>.</span></h3> : checklists != undefined && checklistsFiltered.map((check, i) => 
        <RRChecklist key={`${check.codigo}-${i}`} checklist={check} i={i} FontAwesomeIcon={FontAwesomeIcon} setChecklistToModify={setChecklistToModify} setShowABM={setShowABM} getCheckByID={getCheckByID} eliminarChecklist={eliminarChecklist} actualizarChecklistList={actualizarChecklistList}/>
        )}
        
        {/*showInfo != undefined && <ProcedimientoInfo procedimiento={showInfo} handleLookInfo={handleLookInfo}/>*/}
</div>

}

export default ChecklistList;